import { IGif, INiche, IUser } from "services/types";
import { UserInfo } from "./UserInfo";
import { TagList } from "components/tags";
import { memo, useCallback } from "react";

const MetaInfo = (props: {
  gif: IGif;
  user: IUser | undefined;
  niches: INiche[];
  embedded: boolean;
  rel?: string;
}) => {
  const tags = useCallback(() => {
    return props.gif.tags.map((tag: string) => ({
      name: tag,
      count: 0,
    }));
  }, [props.gif.tags]);

  return (
    <div className="author-wrap">
      {props.user && <UserInfo
        gif={props.gif}
        user={props.user}
        external={props.embedded}
        rel={props.rel}
      />}
      {!props.embedded && (props.gif.tags.length + props.niches.length) > 0 && (
        <TagList niches={props.niches} tags={tags()} />
      )}
    </div>
  );
};

export const MetaInfoMemo = memo(MetaInfo);
